import { getRole, loginOut } from '@/api/login'
import { getToken, removeToken } from '@/utils/auth' // getToken from cookie

const user = {
    state: {
        accountId: "",
        nickname: "",
        accessToken: "",
        lastRole: null,
        gameIds: [],
        hotGameList: false,
        validAccountForm: false,
    },

    mutations: {
        SET_ID: (state, id) => {
            state.accountId = id
        },
        SET_NAME: (state, nickname) => {
            state.nickname = nickname
        },
        SET_TOKEN: (state, token) => {
            state.accessToken = token
        },
        SET_LASTROLE: (state, lastRole) => {
            state.lastRole = lastRole
        },
        SET_GAMEIDS: (state, gameIds) => {
            state.gameIds = gameIds
        },
        HOT_GAME_LIST: (state, bol) => {
            state.hotGameList = bol
        },
        VALID_ACCOUNT_FORM: (state, bol) => {
            state.validAccountForm = bol
        },
    },

    actions: {
        // 获取用户信息
        GetUserInfo({ commit }) {
            return new Promise((resolve, reject) => {
                getRole({ showLastRole: localStorage.getItem('firstLogin') }).then(response => {
                    commit('SET_TOKEN', response.accessToken)
                    commit('SET_NAME', response.nickname)
                    commit('SET_LASTROLE', response.lastRole)
                    commit('SET_ID', response.accountId)
                    commit('SET_GAMEIDS', response.gameIds)
                    if (!response.gameIds.length && localStorage.getItem('firstLogin')) {
                        commit('HOT_GAME_LIST', true)
                        localStorage.removeItem('firstLogin')
                    }
                    if (response.lastRole && localStorage.getItem('firstLogin')) {
                        commit('VALID_ACCOUNT_FORM', true)
                        localStorage.removeItem('firstLogin')
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        hotGameList({ commit }, bol) {
            commit('HOT_GAME_LIST', bol)
        },
        validAccountForm({ commit }, bol) {
            commit('VALID_ACCOUNT_FORM', bol)
        },
        // 登出
        loginOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                loginOut().then(response => {
                    removeToken()
                    commit('SET_TOKEN', "")
                    commit('SET_NAME', "")
                    commit('SET_LASTROLE', null)
                    commit('SET_ID', "")
                    commit('SET_GAMEIDS', [])
                    window.location.reload()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        },
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js